import {
  APPLICATIONS,
  APPLICATIONS_LINK_MAP,
  APPLICATIONS_LINK_MAP_V2,
} from '~/components/ApplicationUrls';

export const ADMIN_REORG_REDIRECTION_CONFIG = {
  //Training routes redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.ADMIN_DASHBOARD].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.ADMIN_DASHBOARD].url,
  'new/ui/admin/programs': 'new/ui/training/programs',
  'new/ui/admin/program/*': 'new/ui/training/program/*',
  'new/ui/admin/archive': 'new/ui/training/archive',
  'new/ui/admin/archive/*': 'new/ui/training/archive/*',
  'new/ui/admin/search': 'new/ui/training/search',
  'new/ui/admin/search/*': 'new/ui/training/search/*',
  'new/ui/admin/scheduled-invitation': 'new/ui/training/scheduled-invitation',
  'new/ui/admin/scheduled-invitation/*': 'new/ui/training/scheduled-invitation/*',
  'new/ui/admin/templates': 'new/ui/training/templates',
  'new/ui/admin/templates/*': 'new/ui/training/templates/*',
  //Users routes redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNERS_URL].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNERS_URL].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNERS_URL].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNERS_URL].url
  }/*`,
  //Profile management redirection
  [APPLICATIONS_LINK_MAP[APPLICATIONS.PROFILE_MANAGEMENT].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.PROFILE_MANAGEMENT].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.PROFILE_MANAGEMENT].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.PROFILE_MANAGEMENT].url
  }/*`,
  //Manage certificates redirection
  'new/ui/manage-certificates': 'new/ui/training/certificates',
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.MANAGE_CERTIFICATES].url}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.MANAGE_CERTIFICATES].url
  }/*`,
  //Tags redirection
  'new/ui/tags': 'new/ui/training/tags',
  'new/ui/tags/*': 'new/ui/training/tags/*',
  // Analytics route redirection
  'new/ui/analytics/dashboard/home': 'new/ui/analytics/my-analytics/dashboard/home',
  'new/ui/analytics/dashboard/manager-home': 'new/ui/analytics/my-analytics/dashboard/manager-home',
  'new/ui/analytics/book-marked/bookmarked-reports':
    'new/ui/analytics/my-analytics/book-marked/bookmarked-reports',
  'new/ui/analytics/custom-created/custom-created-reports':
    'new/ui/analytics/my-analytics/custom-created/custom-created-reports',
  'new/ui/analytics/custom-created/custom-created-reports-beta':
    'new/ui/analytics/my-analytics/custom-created/custom-created-reports-beta',
  'new/ui/analytics/custom-created/advanced-reports':
    'new/ui/analytics/my-analytics/custom-created/advanced-reports',
  'new/ui/analytics/custom-created/custom-created-dashboard':
    'new/ui/analytics/my-analytics/custom-created/custom-created-dashboard',
  'new/ui/analytics/shared/shared-by-me': 'new/ui/analytics/my-analytics/shared/shared-by-me',
  'new/ui/analytics/shared/shared-by-me/dashboard':
    'new/ui/analytics/my-analytics/shared/shared-by-me/dashboard',
  'new/ui/analytics/shared/shared-with-me': 'new/ui/analytics/my-analytics/shared/shared-with-me',
  'new/ui/analytics/shared/shared-with-me/dashboard':
    'new/ui/analytics/my-analytics/shared/shared-with-me/dashboard',
  'new/ui/analytics/series': 'new/ui/analytics/training/series',
  'new/ui/analytics/modules': 'new/ui/analytics/training/modules',
  'new/ui/analytics/competency-assessment': 'new/ui/analytics/training/competency-assessment',
  'new/ui/analytics/dashboard/engagement': 'new/ui/analytics/assets/dashboard/engagement',
  'new/ui/analytics/widgets/asset-hub/assets': 'new/ui/analytics/assets/widgets/asset-hub/assets',
  'new/ui/analytics/widgets/asset-hub/audit-reports/admins':
    'new/ui/analytics/assets/widgets/asset-hub/audit-reports/admins',
  'new/ui/analytics/widgets/asset-hub/users': 'new/ui/analytics/assets/widgets/asset-hub/users',
  'new/ui/analytics/dashboard/revenue-impact': 'new/ui/analytics/assets/dashboard/revenue-impact',
  'new/ui/analytics/widgets/asset-hub/revenue-impact':
    'new/ui/analytics/assets/widgets/asset-hub/revenue-impact',
  'new/ui/analytics/widgets/asset-hub/audit-reports/assets':
    'new/ui/analytics/assets/widgets/asset-hub/audit-reports/assets',
  'new/ui/analytics/managers': 'new/ui/analytics/users-and-roles/managers-hierarchy',
  'new/ui/analytics/managers/relationship':
    'new/ui/analytics/users-and-roles/managers-relationship',
  'new/ui/analytics/managers/*': 'new/ui/analytics/users-and-roles/managers/*',
  'new/ui/analytics/learners': 'new/ui/analytics/users-and-roles/learners',
  'new/ui/analytics/learners/*': 'new/ui/analytics/users-and-roles/learners/*',
  'new/ui/analytics/groups': 'new/ui/analytics/users-and-roles/groups',
  'new/ui/analytics/groups/*': 'new/ui/analytics/users-and-roles/groups/*',
  'new/ui/analytics/reviewers': 'new/ui/analytics/users-and-roles/reviewers/mission',
  'new/ui/analytics/reviewers/mission': 'new/ui/analytics/users-and-roles/reviewers/mission',
  'new/ui/analytics/reviewers/coaching': 'new/ui/analytics/users-and-roles/reviewers/coaching',
  'new/ui/analytics/dashboard/adoption': 'new/ui/analytics/training/dashboard/adoption',
  'new/ui/analytics/dashboard/performance': 'new/ui/analytics/training/dashboard/performance',
  'new/ui/analytics/tags/overview': 'new/ui/analytics/training/dashboard/tags/overview',
  'new/ui/analytics/tags/details': 'new/ui/analytics/training/dashboard/tags/details',
  'new/ui/analytics/tags/segment-heatmap':
    'new/ui/analytics/training/dashboard/tags/segment-heatmap',
  'new/ui/analytics/tags/learner-heatmap':
    'new/ui/analytics/training/dashboard/tags/learner-heatmap',
  'new/ui/analytics/callai-adoption-dashboard/*':
    'new/ui/analytics/callai/callai-adoption-dashboard/*',
  profile: APPLICATIONS_LINK_MAP_V2[APPLICATIONS.PROFILE].url,
  // Account Setting URLs
  'new/ui/training/settings/*': 'new/ui/account-settings/settings/training/*',
  'new/ui/assets/settings/*': 'new/ui/account-settings/settings/assets/*',
  'new/ui/admin/callai/admin/general-settings':
    'new/ui/account-settings/settings/callai/general-settings',
  'new/ui/admin/callai/admin/integrations': 'new/ui/account-settings/settings/callai/integrations',
  'new/ui/admin/callai/admin/call-score-setup':
    'new/ui/account-settings/settings/callai/call-score-setup',
  'new/ui/admin/callai/admin/themes': 'new/ui/account-settings/settings/callai/themes',
  'new/ui/admin/callai/admin/analytics-configuration':
    'new/ui/account-settings/settings/callai/analytics-configuration',
  'new/ui/analytics/settings': 'new/ui/account-settings/settings/analytics',
  'new/ui/account-settings/sign-in': 'new/ui/account-settings/settings/sign-in',
  'new/ui/account-settings/language': 'new/ui/account-settings/settings/language',
  'new/ui/system-logs/audit': 'new/ui/account-settings/system-logs/audit',
  'new/ui/system-logs/email': 'new/ui/account-settings/system-logs/email',
  'new/ui/analytics/custom-created': 'new/ui/analytics/my-analytics/custom-created',
};

export const LEARNER_REORG_REDIRECTION_CONFIG = {
  // coaching and mission dashboard redirections
  'new/ui/learner/coaching-dashboard': 'new/ui/learner/review/coaching-dashboard',
  'new/ui/learner/coaching-dashboard/*': 'new/ui/learner/review/coaching-dashboard/*',
  'new/ui/learner/mission-dashboard': 'new/ui/learner/review/mission-dashboard',
  'new/ui/learner/mission-dashboard/*': 'new/ui/learner/review/mission-dashboard/*',
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url,
  [`${[APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url]}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_READINESS_PROGRAMS].url
  }/*`,
  [APPLICATIONS_LINK_MAP[APPLICATIONS.MODULE_LIBRARY].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.MODULE_LIBRARY].url,
  [APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_PEERS].url]:
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_PEERS].url,
  [`${APPLICATIONS_LINK_MAP[APPLICATIONS.CONTENT_MEDIA_VOSS].url}/sme`]: APPLICATIONS_LINK_MAP_V2[
    APPLICATIONS.TASKS
  ].url,
  [`${[APPLICATIONS_LINK_MAP[APPLICATIONS.LEARNER_PEERS].url]}/*`]: `${
    APPLICATIONS_LINK_MAP_V2[APPLICATIONS.LEARNER_PEERS].url
  }/*`,
  // learner analytics route redirection
  'new/ui/analytics/dashboard/manager-home': 'new/ui/analytics/my-analytics/dashboard/manager-home',
  'new/ui/analytics/book-marked/bookmarked-reports':
    'new/ui/analytics/my-analytics/book-marked/bookmarked-reports',
  'new/ui/analytics/shared/shared-with-me': 'new/ui/analytics/my-analytics/shared/shared-with-me',
  'new/ui/analytics/shared/shared-with-me/dashboard':
    'new/ui/analytics/my-analytics/shared/shared-with-me/dashboard',
  'new/ui/analytics/callai-adoption-dashboard/*':
    'new/ui/analytics/callai/callai-adoption-dashboard/*',
};
